import { doodBlockConfig, propertyValue } from "./dood-block-config";
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from "./descriptor-field-order";
import type { IBlockDescriptor } from "./descriptor";

export const HTML_LEGACY_FIELD_ORDER = [
  "html",
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  htmlBlockDescriptor: _generatedHtmlBlockDescriptor,
  htmlBlockBlocDefinition,
  htmlBlockDashboardLayout,
  htmlBlockConfig,
  htmlBlockResolveConfig,
  htmlBlockProperties,
} = doodBlockConfig(
  {
    name: "HTML",
    componentType: "HtmlBlockComponent",
    category: "system",
    description: "Raw HTML block for advanced styling snippets.",
    keywords: ["html", "css", "advanced"],
    sharedFields: {},
  },

  () => ({
    html: propertyValue({
      type: "textarea",
      value: "",
      options: {
        label: "pages.blocks.html.html.label",
        help: "pages.blocks.html.html.help",
        rows: 20,
        monospace: true,
      },
    }),
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.html.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.html.fieldset.code.label",
            fields: ["html"],
          },
        ],
      },
    ],
  }),
);

export function htmlBlockDescriptor(): IBlockDescriptor;
export function htmlBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function htmlBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedHtmlBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(
    _generatedHtmlBlockDescriptor,
    htmlBlockProperties,
    fieldOrder,
  );
}

export {
  htmlBlockBlocDefinition,
  htmlBlockDashboardLayout,
  htmlBlockConfig,
  htmlBlockResolveConfig,
  htmlBlockProperties,
};

export type HtmlBlockConfig = typeof htmlBlockConfig;
